export default __webpack_public_path__ + "static/media/Q12_0_resized.ca5325e8.jpg";